<template>
  <v-dialog v-model="allDialog" width="400" class="register_container">
    <v-card class="mx-auto" style="width: 400px;">
      <div class="d-flex justify-start align-center flex-column">
        <div
          class="pa-5"
          style="
            font-size: 20px;
            font-weight: bold;
            width: 100%;
            text-align: left;
          "
        >
          {{ $i18n.t("login.sign_up") }}
        </div>
        <div class="py-0" style="width: 100%;">
          <v-form ref="login_form" v-model="valid" class="px-4 py-2">
            <v-text-field
              v-model="user.email"
              prepend-inner-icon="mdi-email"
              name="email"
              :label="$i18n.t('login.Please_enter_email_address')"
              type="email"
              required
              :rules="[required, email]"
              outlined
            />
            <v-text-field
              id="password"
              v-model="user.password"
              prepend-inner-icon="mdi-lock"
              name="password"
              :label="$i18n.t('login.Please_enter_your_password')"
              :rules="[required, counter]"
              required
              :type="isShowPassword ? 'text' : 'password'"
              outlined
            >
              <v-fade-transition slot="append" mode="out-in">
                <v-icon
                  :key="`icon-${isShowPassword}`"
                  @click="isShowPassword = !isShowPassword"
                  v-text="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                />
              </v-fade-transition>
            </v-text-field>

            <v-text-field
              v-model.trim="user.passwordR"
              :label="$i18n.t('login.confirm_password')"
              prepend-inner-icon="mdi-lock"
              :type="isShowPassword2 ? 'text' : 'password'"
              :rules="[required]"
              :error="user.passwordR !== user.password"
              :error-messages="
                user.passwordR !== user.password
                  ? $i18n.t('login.confirm_password')
                  : ''
              "
              outlined
            >
              <v-fade-transition slot="append" mode="out-in">
                <v-icon
                  :key="`icon-${isShowPassword}`"
                  @click="isShowPassword2 = !isShowPassword2"
                  v-text="isShowPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                />
              </v-fade-transition>
            </v-text-field>

            <div class="d-flex flex-column-reverse all-center">
              <div class="text-center" style="width: 100%;">
                <v-dialog v-model="dialog" width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      style="width: 100%;"
                      color="#3f57bb"
                      @click="getPic"
                      ref="signUpButton"
                      class="common-button white--text"
                      v-text="$i18n.t('sign_up')"
                    >
                    </v-btn>
                  </template>

                  <v-card style="margin-right: 1px;">
                    <v-card-title
                      class="headline grey lighten-2 all-center"
                      primary-title
                    >
                      {{ $i18n.t("login.Please_click_on_each_other") }}:
                      {{ tips[0] }} {{ tips[1] }} {{ tips[2] }} {{ tips[3] }}
                    </v-card-title>

                    <v-card-text class="all-center" style="padding: 10px;">
                      <div
                        style="
                          position: relative;
                          background-color: #333;
                          width: 300px;
                          height: 200px;
                        "
                      >
                        <img :src="imgSrc" alt="" />
                        <div
                          @click="getPosition"
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 100%;
                            height: 100%;
                            background-color: transparent;
                          "
                        >
                          <div
                            :style="{
                              top: position.y + 'px',
                              left: position.x + 'px',
                            }"
                            v-for="(position, index) in positionArray"
                            :key="position.x + index"
                            class="verity-number all-center"
                          >
                            {{ index + 1 }}
                          </div>
                        </div>
                      </div>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn color="primary" text @click="refreshPic">
                        {{ $i18n.t("login.refresh") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        {{ $i18n.t("login.finish") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </v-form>
        </div>
      </div>

      <div class="d-flex justify-center align-center mt-n5">
        <div class="ma-0 pa-0 pl-4 mb-10" style="height: 30px;">
          <v-checkbox
            v-model="agree"
            style="font-size: 14px;"
            color="#3f57bb"
            :label="$i18n.t('login.agree')"
          ></v-checkbox>
        </div>
        <div
          class="text-left ma-0 pa-0 pl-3"
          style="
            height: 30px;
            cursor: pointer;
            color: #3f57bb;
            font-size: 14px;
            margin-top: 5px !important;
          "
          @click="toService"
        >
          {{ $i18n.t("login.service_agreement") }}
        </div>
        <v-spacer></v-spacer>
        <div
          @click="toSignIn"
          class="text-center ma-0 pa-0 pr-4"
          style="
            height: 30px;
            cursor: pointer;
            color: #3f57bb;
            font-size: 14px;
            margin-top: 5px !important;
          "
        >
          {{ $i18n.t("login.Existing_account_to_log_in") }}
        </div>
      </div>
      <v-snackbar
        v-model="snackbarInfo.status"
        :color="snackbarInfo.color"
        top
        dark
      >
        <v-icon color="white" class="mr-3">
          {{ snackbarInfo.icon }}
        </v-icon>
        <span v-text="snackbarInfo.msg"></span>
        <v-icon size="16" color="white" @click="snackbarInfo.status = false">
          mdi-close-circle
        </v-icon>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {},
  data: () => ({
    allDialog: false,
    sessionId: "",
    imgSrc: "",
    tips: [],
    SignUpFail: false,
    valid: false,
    isRepeat: false, //为了检查用户名是否重复
    positionArray: [],
    showPic: false,
    dialog: false,
    user: {
      email: "",
      password: "",
      passwordR: "",
    },
    agree: true,
    snackbarInfo: {
      status: "",
      color: "",
      msg: "",
      icon: "",
    },
    isShowPassword: false,
    isShowPassword2: false,
  }),
  mounted() {
    this.allDialog = this.showSignUp;
    document.onkeyup = (e) => {
      if (e.key === "Enter") {
        if (this.valid && this.agree) {
          this.getVerify().then((res) => {
            console.log(res);
            this.imgSrc = "data:image/png;base64," + res.data.data.base64String;
            this.sessionId = res.data.data.id;
            this.tips = res.data.data.tips;
            console.log(this.sessionId);
            this.showPic = true;
            this.positionArray = [];
            this.dialog = true;
            console.log(this.imgSrc, this.sessionId);
          });
        }
      }
    };
  },
  computed: {
    ...mapState(["loading", "showSignUp"]),
    testEmail() {
      const pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      return pattern.test(this.user.email);
    },
  },
  methods: {
    ...mapMutations([
      "SET_PATH",
      "SET_SHOW_SIGNUP",
      "SET_SHOW_SIGNIN",
      "SET_SIGN_IN",
      "SET_SNACK_INFO",
    ]),
    ...mapActions(["signUp", "getVerify", "checkVerify"]),
    toService() {
      window.open("#/service");
    },
    refreshPic() {
      this.positionArray = [];
      this.getPic();
    },
    closeSignUp() {
      this.SET_SHOW_SIGNUP(false);
    },
    toSignIn() {
      this.SET_SHOW_SIGNIN(true);
      this.SET_SHOW_SIGNUP(false);
    },
    getPic() {
      if (this.valid && this.agree) {
        this.dialog = true;
        this.getVerify().then((res) => {
          console.log(res);
          this.imgSrc = "data:image/png;base64," + res.data.data.base64String;
          this.sessionId = res.data.data.id;
          this.tips = res.data.data.tips;
          console.log(this.sessionId);
          this.showPic = true;
          this.dialog = true;
          this.positionArray = [];
        });
      } else {
        this.dialog = false;
        this.SET_SNACK_INFO({
          status: true,
          color: "error",
          msg:
            "Please tick to agree to the user agreement and fill in it completely",
          timeout: 2000,
        });
      }
    },
    getPosition(e) {
      let position = { x: e.offsetX, y: e.offsetY };
      if (this.positionArray.length < 4) {
        this.positionArray.push(position);
        if (this.positionArray.length === 4) {
          this.dialog = false;
          this.checkVerify({
            sessionId: this.sessionId,
            addresses: [...this.positionArray],
          }).then((res) => {
            if (res.data.code === 200) {
              let password = this.$md5(this.user.password);
              this.signUp({ email: this.user.email, password: password }).then(
                (res) => {
                  if (res.data.code === 200) {
                    this.SET_SHOW_SIGNUP(false);
                    this.$router.push("/");
                  } else if (res.data.code === 606) {
                    this.SignUpFail = true;
                  }
                }
              );
            } else {
            }
          });
        }
      }
    },
    required(value) {
      return !!value || this.$i18n.t("login.What is required");
    },
    email(value) {
      const pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      return (
        pattern.test(value) ||
        this.$i18n.t("login.Please enter the correct mailbox")
      );
    },
    counter(value) {
      return (
        value.length >= 8 ||
        this.$i18n.t("login.Cannot be less than 8 characters")
      );
    },
  },
  watch: {
    allDialog: {
      handler(newV) {
        if (!newV) {
          this.SET_SHOW_SIGNUP(false);
        }
      },
    },
  },
};
</script>
<style lang="scss">
@import "../utils/common";

.register_container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
